import { CheckStyleKinds, PaintStyle } from "../../drawing";
import { AbstractCheckableItem, CheckableItemValueSource } from "./AbstractCheckableItem";
import { INameGroupEmptyValidatable } from "./INameGroupEmptyValidatable";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { TypeKeys } from "./TypeKeys";
import { IHisInformationSelectable } from "./IHisInformationSelectable";
import { IFreeInputable } from "./IFreeInputable";
import { INaturalTextSpecifiable } from "./INaturalTextSpecifiable";

export class CheckBoxItem extends AbstractCheckableItem implements IPaintableOnEditing, INameGroupEmptyValidatable, IFreeInputable, IHisInformationSelectable, INaturalTextSpecifiable {
  constructor(isChecked: boolean, checkedValue: number, uncheckedValue: number) {
    super(TypeKeys.CheckBoxItem, new CheckableItemValueSource(isChecked, checkedValue, uncheckedValue));
  }

  public shouldDrawBorder: boolean = false;
  public checkStyle: CheckStyleKinds = CheckStyleKinds.Check;
  public paintStyle: PaintStyle = new PaintStyle();
  public paintStyleOnEditing: PaintStyle = new PaintStyle();
 
  protected createCloneInstance(): CheckBoxItem {
    return new CheckBoxItem(
      this.originalValueSource.isChecked,
      this.originalValueSource.checkedValue,
      this.originalValueSource.uncheckedValue);
  }

  protected applyMembers(clone: CheckBoxItem): void {
    super.applyMembers(clone);
    clone.shouldDrawBorder = this.cloneValue(this.shouldDrawBorder);
    clone.checkStyle = this.cloneValue(this.checkStyle);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
  }

  get isEmpty(): boolean {
    return !this.isChecked;
  }

  get currentNaturalText(): string {
    return this.isChecked
      ? (this.isNaturalViewEnable && this.naturalText)
        ? this.naturalText
        : this.itemName + "\n"
      : "";
  }
}
